import tailwindConfig from '@root/tailwind.config';
import { LineLayerSpecification } from 'maplibre-gl';

import {
  AcresMapboxLayerIds,
  AcresMapboxSourceIds,
  AcresMapboxVectorSourceLayerIds,
  ZOOM_LEVELS,
} from '..';

const jade = tailwindConfig.theme.extend.colors.jade.DEFAULT;

export const townshipOutlineLayer: LineLayerSpecification = {
  id: AcresMapboxLayerIds.TOWNSHIP_OUTLINE,
  layout: {
    visibility: 'visible',
  },
  maxzoom: ZOOM_LEVELS.TOWNSHIPS.MAX,
  minzoom: ZOOM_LEVELS.TOWNSHIPS.MIN,
  paint: {
    'line-color': jade,
    'line-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      1,
      0,
    ],
    'line-width': 5,
  },
  source: AcresMapboxSourceIds.COUNTY_SUBDIVISIONS,
  'source-layer': AcresMapboxVectorSourceLayerIds.COUSUB,
  type: 'line',
};

export const townshipOutlinePermanentLayer: LineLayerSpecification = {
  ...townshipOutlineLayer,
  id: AcresMapboxLayerIds.TOWNSHIP_OUTLINE_PERMANENT,
};
